import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { CmsApiResponse, CmsPageService } from '../../services/cms-page.service';
import { parseHomeCmsContent } from '../../config/home-cms.defaults';
import { HeroSwapComponent } from '../hero-swap/hero-swap.component';
import { EcosystemHubComponent } from '../ecosystem-hub/ecosystem-hub.component';
import { FinancialTerminalComponent } from '../financial-terminal/financial-terminal.component';
import { FarmsSectionComponent } from '../farms-section/farms-section.component';
import { StakingSectionComponent } from '../staking-section/staking-section.component';
import { PromosTrustComponent } from '../promos-trust/promos-trust.component';

@Component({
  selector: 'app-home',
  standalone: true,
  templateUrl: './home.component.html',
  imports: [
    HeroSwapComponent,
    EcosystemHubComponent,
    FinancialTerminalComponent,
    FarmsSectionComponent,
    StakingSectionComponent,
    PromosTrustComponent,
  ],
})
export class HomeComponent implements OnInit, OnDestroy {
  public state = inject(AppStateService);
  private route = inject(ActivatedRoute);
  private cmsPageService = inject(CmsPageService);
  private routeSub?: Subscription;

  ngOnInit() {
    this.routeSub = this.route.data.subscribe((data) => {
      this.state.applyHomeCmsResponse(data['cmsResponse'] as CmsApiResponse | null);
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }
}
